import {z} from 'zod';
import {captureException} from '@sentry/react';
import {getViewportStorageKey} from './keys';

const viewportSchema = z.object({
  x: z.number(),
  y: z.number(),
  zoom: z.number(),
});

type StoredViewport = z.infer<typeof viewportSchema>;

/**
 * Get the stored viewport from localStorage.
 * Returns null if no viewport is stored or if the stored data is invalid.
 */
export function getStoredViewport(flowId: string): StoredViewport | null {
  const storageKey = getViewportStorageKey(flowId);
  const savedViewport = localStorage.getItem(storageKey);

  if (!savedViewport) {
    return null;
  }

  try {
    return viewportSchema.parse(JSON.parse(savedViewport));
  } catch (error) {
    captureException(error, {
      tags: {area: 'canvas'},
      extra: {flowId, savedViewport},
    });
    // Clear invalid viewport data
    localStorage.removeItem(storageKey);
    return null;
  }
}

/**
 * Save the viewport to localStorage.
 */
export function saveViewport(flowId: string, viewport: StoredViewport): void {
  localStorage.setItem(getViewportStorageKey(flowId), JSON.stringify(viewport));
}
